import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/guides/installation/page.tsx");
